import { useCallback, useState } from "react";
import { useParams } from "react-router-dom";

import API from "Signups/API";
import { useReplaceAllSignupListItems } from "Signups/stateHooks";

const useCopyExtendedFields = () => {
  const { signupItemID } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [hasSuccess, setSuccess] = useState(false);

  const replaceAllSignupListItems = useReplaceAllSignupListItems();

  const copyExtendedFields = useCallback(() => {
    setIsLoading(true);
    setHasError(false);
    setSuccess(false);
    API.copyExtendedFields({ signupListItemID: Number(signupItemID) })
      .post()
      .then((res) => {
        const items = res?.items;
        replaceAllSignupListItems(items);
        setSuccess(true);
      })
      .catch(() => {
        setHasError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [signupItemID, replaceAllSignupListItems]);

  return [{ isLoading, hasError, hasSuccess }, copyExtendedFields];
};

export { useCopyExtendedFields };
